export default __webpack_public_path__ + "static/media/rocket_anim_42.6057f37d.png";